<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Terminate Subscriber</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<!--						<route-bread-crumb></route-bread-crumb>-->
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container class="pt-5 w-50" style="min-width: max-content; max-width: 600px;">


			<b-card>
				<b-card-header>
					<h3 class="mb-0">Terminate Subscriber</h3>
				</b-card-header>
				<b-card-body>
					<b-form>
						<b-row>
							<b-col xl="12" lg="12" sm="12">
								<p>
									This form will terminate an ACTIVE subscriber and remove it from all provisioning
									services.
								</p>

								<b-input-group prepend="IMSI" label-for="input-1">
									<b-form-input
										:state="imsiValidation"
										v-model="terminateSubscriberForm.imsiInfo"
										required
									></b-form-input>
								</b-input-group>
							</b-col>
						</b-row>
					</b-form>
				</b-card-body>
				<b-card-footer>
					<b-row class="mt-3 justify-content-end">
						<b-col>
							<div class="float-right">
								<!--								<base-button id="btn-terminate-modal-submit" type="primary" title="Submit"-->
								<!--											 :disabled="!imsiValidation||isLoading"-->
								<!--											 v-on:click="terminateSubscriberSubmit()">-->
								<!--									Terminate-->
								<!--								</base-button>-->
								<!--								<br/>-->
								<b-button
									type="submit"
									variant="primary"
									class="btn btn-primary"
									v-if="!isLoading"
									:disabled="!imsiValidation||isLoading"
									v-on:click="terminateSubscriberSubmit()"
								>
									Terminate
								</b-button>
								<b-button
									variant="primary"
									class="btn btn-primary"
									disabled
									v-if="isLoading"
								>
									<b-icon icon="circle-fill" animation="throb" font-scale="1"></b-icon>
									Processing...
								</b-button>

							</div>
						</b-col>
					</b-row>

				</b-card-footer>
			</b-card>
		</b-container>

		<!--no-close-on-backdrop-->
		<b-modal centered size="sm" id="activity_progress_bar" hide-footer hide-header
				 class="activity_progress_bar ">
			<p class="h1 text-center mb-4">Activity</p>
			<b-progress :value="progressStartValue" height="16px" variant="primary" :striped="true"
						class="mt-2" :animated="true" show-progress></b-progress>
			<div class="text-center">
				<small class="text-center" v-if="progressTitle">{{ progressTitle }}</small>
				<br>
				<small class="text-center" v-if="progressMessage">{{ progressMessage }}</small>
			</div>
		</b-modal>
	</div>
</template>


<script>
import provisioningService from "@/common/api-services/provisioning-service";
import ToastVue from "@/views/Components/Toast.vue";
import AuthService from "@/common/api-services/auth-service";
import searchDashboardService from "@/common/api-services/search-dashboard-service";


export default {
	name: "Terminate-Subscriber",
	components: {ToastVue},
	data() {
		return {
			lastMessage: "",
			terminateSubscriberForm: {
				imsiInfo: "",
			},
			progressTitle: null,
			progressMessage: null,
			progressStartValue: 5,
			isLoading: false,
		};
	},
	computed: {
		imsiValidation() {
			return this.terminateSubscriberForm.imsiInfo.length === 15;
		},
	},
	mounted() {
		this.$bvModal.hide("activity_progress_bar");
		this.$root.$on("sendIMSIInfo", (imsi => {
			this.terminateSubscriberForm.imsiInfo = imsi;
		}));
	},
	methods: {

		setProgressTimer() {
			this.timer = setInterval(() => {
				this.progressStartValue = this.progressStartValue + Math.random() * 300 / this.progressStartValue;
				if (this.progressStartValue > 100) {
					this.progressStartValue = 10;
				}
			}, 1000);
		},

		async terminateSubscriberSubmit() {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimDetail.vue] terminateSubscriberSubmit...", Date.now(), Date());
			let re = /^[0-9]{15}$/gm;
			if (!re.test(this.terminateSubscriberForm.imsiInfo)) {
				let msg = {
					status: "ERROR",
					response: {
						error: "Invalid IMSI: " + this.terminateSubscriberForm.imsiInfo,
					},
				};
				this.processMessage(msg);
				return;
			}

			//do the IOT version
			//if (configDirective.isIOTOnly()) {
			this.isLoading = true;
			let status = null;
			await searchDashboardService.getSimInfo(this.terminateSubscriberForm.imsiInfo).then(res => {
				console.log("getSimInfo_BEFORE:", res);
				if (res) {
					status = res.status;
					if (status === "Inactive") {
						this.$toast.warning({
							component: ToastVue,
							props: {
								title: "TERMINATE Subscriber: Cancelled",
								description: "Sim was already in an Inactive state.",
							},
						}, {
							timeout: 45000,
						});
					}
				}
			});
			if (status === "Inactive") {
				this.isLoading = false;
				return;
			}

			let update = null;
			await provisioningService.submitSimpleTerminate(this.terminateSubscriberForm.imsiInfo).then(res => {
				console.log("submitSimpleTerminate:", res);
				update = res;
			}).catch(err => {
				console.error("submitSimpleTerminate_ERROR:", err);
				update = err;
			});

			status = null;
			await searchDashboardService.getSimInfo(this.terminateSubscriberForm.imsiInfo).then(res => {
				console.log("getSimInfo_AFTER:", res);
				if (res) {
					status = res.status;
					if (status !== "Inactive") {
						this.$toast.error({
							component: ToastVue,
							props: {
								title: "TERMINATE Subscriber: FAILED",
								description: "Sim was not terminated successfully. STATUS:" + status,
							},
						}, {
							timeout: 45000,
						});
					} else {
						this.$toast.success({
							component: ToastVue,
							props: {
								title: "TERMINATE Subscriber: OK",
								description: "Sim was successfully terminated. STATUS:" + status,
							},
						}, {
							timeout: 45000,
						});
					}
				}
			});
			this.isLoading = false;

		},

		processMessage(msg) {

			if (!msg || String(msg).length < 5) return;
			if (JSON.stringify(this.lastMessage) === JSON.stringify(msg)) return;
			if (process.env.NODE_ENV === "dev") console.log("TERMINATE:", msg);

			if (JSON.stringify(msg).toLowerCase().indexOf("error") || JSON.stringify(msg).toLowerCase().indexOf("fail")) {
				msg.status === "ERROR";
			}

			if (msg.status === "DONE" || msg.status === "ERROR") {
				this.addLog(msg.response, msg.status === "ERROR" ? 1 : 0);
				let messageData = "";
				if (msg && msg.response) {
					try {
						let j = JSON.parse(msg.response);
						if (j.success) {
							j.success.map(item => {
								messageData = messageData + item + `<br>`;
							});
						}
						if (j.error) {
							j.error.map(item => {
								messageData = messageData + item + `<br>`;
							});
						}
					} catch (e) {
						console.error(e);
					} //ignore
				}

				if (process.env.NODE_ENV === "dev") {
					console.log("processMessage.msg:", msg);
					console.log("processMessage.STATUS:", msg.status);
					console.log("processMessage.messageData:", messageData);
				}

				if (msg.status === "ERROR") {
					if (typeof msg.details === "undefined") {
						// this.addLog(messageData, 1)
						this.$toast.error({
							component: ToastVue,
							props: {
								title: "Terminate Subscriber",
								subtitle: "There was an error removing the SIM from the system.  Please try again or refer to the logs for more details.",
								description: JSON.stringify(messageData),
							},
						});
					}
				} else {
					// this.addLog(messageData, 0)
					this.$toast.success({
						component: ToastVue,
						props: {
							title: "Terminate Subscriber",
							subtitle: "The SIM was terminated successfully and is now available for reuse.",
							description: JSON.stringify(messageData),
						},
					});
					//this.$root.$emit('reloadSimDetailPageData', this.terminateSubscriberForm.imsiInfo);
				}
				this.closeModal();
			} else {
				this.progressMessage = msg.status;
			}
			this.lastMessage = msg;
		},

		addLog(details, isError = 0) {
			AuthService.setActivityLog("Mobility: Terminate Subscriber", details, isError);
		},

		closeModal() {
			//reload the page data or just show it.
			this.progressMessage = "Refreshing Subscriber data...";
			// //window.location.reload();
			// this.$forceUpdate();
			// this.$root.$emit('reloadSimDetailPageData', this.terminateSubscriberForm.imsiInfo);

			setTimeout(() => {
				this.$bvModal.hide("activity_progress_bar");
				//this.$bvModal.hide('terminate-subscriber');
			}, 1000);
		},

	},
};
</script>

